import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'carm-main-footer-main-section',
  templateUrl: './main-footer-main-section.component.html',
  styleUrls: ['./main-footer-main-section.component.scss'],
})
export class MainFooterMainSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
